import { MessageFeedback } from '../../types/chatTypes'
import { axiosClient } from '../axiosClient'

export const messageFunctions = {
  fetchMessageFeedback: async (messageId: string): Promise<MessageFeedback> => {
    return await axiosClient.get(`api/chat/messages/${messageId}/feedback`)
  },

  updateMessageFeedback: async (
    messageId: string,
    feedback: {
      is_good_response: boolean
      is_bad_response: boolean
      reason_bad_response?: string
      feedback_bad_response?: string
    },
  ): Promise<MessageFeedback> => {
    return await axiosClient.patch(`api/chat/messages/${messageId}/feedback`, feedback)
  },

  updateMessage: async (message: {
    id: string
    is_bad_response: boolean
    is_good_response: boolean
    reason_bad_response?: string
    feedback_bad_response?: string
  }): Promise<void> => {
    const body = {
      is_bad_response: message.is_bad_response,
      is_good_response: message.is_good_response,
      reason_bad_response: message.reason_bad_response,
      feedback_bad_response: message.feedback_bad_response,
    }

    return await axiosClient.patch(`api/chat/messages/${message.id}/feedback`, body)
  },
}
